import { getOwaCommonStrings } from 'owa-strings/owa-common-strings';
import createSingularPluralStrings from 'owa-measurementunit-formatter/lib/createSingularPluralStrings';

// Groups the strings for each unit
export default function getAbbreviatedSingularPluralStrings() {
    return {
        year: createSingularPluralStrings(
            getOwaCommonStrings().yearSingularAbbreviation,
            getOwaCommonStrings().yearFirstPluralAbbreviation,
            getOwaCommonStrings().yearSecondGenitivePluralAbbreviation
        ),
        month: createSingularPluralStrings(
            getOwaCommonStrings().monthSingularAbbreviation,
            getOwaCommonStrings().monthFirstPluralAbbreviation,
            getOwaCommonStrings().monthSecondGenitivePluralAbbreviation
        ),
        week: createSingularPluralStrings(
            getOwaCommonStrings().weekSingularAbbreviation,
            getOwaCommonStrings().weekFirstPluralAbbreviation,
            getOwaCommonStrings().weekSecondGenitivePluralAbbreviation
        ),
        day: createSingularPluralStrings(
            getOwaCommonStrings().daySingularAbbreviation,
            getOwaCommonStrings().dayFirstPluralAbbreviation,
            getOwaCommonStrings().daySecondGenitivePluralAbbreviation
        ),
        hour: createSingularPluralStrings(
            getOwaCommonStrings().hourSingularAbbreviation,
            getOwaCommonStrings().hourFirstPluralAbbreviation,
            getOwaCommonStrings().hourSecondGenitivePluralAbbreviation
        ),
        minute: createSingularPluralStrings(
            getOwaCommonStrings().minuteSingularAbbreviation,
            getOwaCommonStrings().minuteFirstPluralAbbreviation,
            getOwaCommonStrings().minuteSecondGenitivePluralAbbreviation
        ),
        second: createSingularPluralStrings(
            getOwaCommonStrings().secondSingularAbbreviation,
            getOwaCommonStrings().secondFirstPluralAbbreviation,
            getOwaCommonStrings().secondSecondGenitivePluralAbbreviation
        ),
    };
}
